<template>
    <v-container class="pr-0 pt-0">
        <v-row column justify-center align-center>
            <v-col
                v-if="content && content.blurbage && content.blurbage[$i18n.locale]"
                cols="12"
                class="py-0"
            >
                <BlockContent
                    :blocks="content.blurbage[$i18n.locale]"
                    :serializers="serializers"
                />
            </v-col>
            <v-col
                v-for="item in contactInfoList"
                :key="item._key"
                cols="12"
                xs="12"
                sm="6"
                md="6"
                lg="6"
                xl="6"
                class="pa-0 pr-1"
            >
                <v-list class="d-flex flex-wrap">
                    <v-list-item>
                        <v-list-item-icon
                            v-if="
                                item.icon &&
                                    item.icon.length > 0 &&
                                    item.icon[0].snake
                            "
                            :class="`${$vuetify.breakpoint.md? 'mr-2' : ''}`"
                        >
                            <fa
                                :icon="['fal', item.icon[0].snake]"
                                :class="`${$vuetify.breakpoint.md? 'fa-lg' : 'fa-xl'}`"
                            />
                        </v-list-item-icon>
                        <v-list-item-content>
                            <v-list-item-title
                                v-if="item.label && item.label[$i18n.locale]"
                                class="title"
                            >
                                {{
                                    item.label && item.label[$i18n.locale]
                                        ? item.label[$i18n.locale]
                                        : ''
                                }}
                            </v-list-item-title>
                            <v-list-item-subtitle
                                v-if="
                                    item.content && item.content[$i18n.locale]
                                "
                                :class="`subtitle-1 ${$vuetify.breakpoint.md? 'custom-subtitle' : ''}`"
                            >
                                <BlockContent
                                    :blocks="item.content[$i18n.locale]"
                                    :serializers="serializers"
                                />
                            </v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-col>
        </v-row>
    </v-container>
</template>
<script>
import serializers from '~/util/sanity/serializers'
export default {
    name: 'ContactPoints',
    components: {},
    props: {
        content: {
            type: Object,
            default: null,
        }
    },
    data() {
        return { serializers }
    },
    computed: {
        contactInfoList() {
            return this.$store.state.common.siteSettings.contactPoints
        }
    },
    methods: {}
}
</script>
<style scoped>
.custom-subtitle {
    font-size: 0.8rem !important;
}
</style>
